module.exports = __webpack_public_path__ + "static/media/company_logo2.54dd1070.png";